import { render, staticRenderFns } from "./card-recap.vue?vue&type=template&id=45896db2&scoped=true"
import script from "./card-recap.vue?vue&type=script&lang=js"
export * from "./card-recap.vue?vue&type=script&lang=js"
import style0 from "./card-recap.vue?vue&type=style&index=0&id=45896db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45896db2",
  null
  
)

export default component.exports